import React, { useState, useEffect } from 'react';
import AddButton from '../../../components/common/AddButton/AddButton';
import Filter from '../../../components/common/Filter/Filter';
import Sort from '../../../components/common/Sort/Sort';
import EditPopup from '../../../components/Popup/EditPopup/EditPopup'; 
import AddPopup from '../../../components/Popup/AddPopup/AddPopup';
import ArchivePopup from '../../../components/Popup/ArchivePopup/ArchivePopup';
import EditIcon from '../../../components/Table/EditIcon/EditIcon';
import ArchiveIcon from '../../../components/Table/ArchiveIcon/ArchiveIcon';
import ExportLabel from '../../../components/common/ExportLabel/Export';
import PageHeader from '../../../components/common/PageHeader/PageHeader';
import SimpleSearchBox from '../../../components/common/Search/SimpleSearch';
import DetailIcon from '../../../components/Table/DetailIcon/DetailIcon';
import { baseurl } from '../../../api';
import DetailPopup from '../../../components/Popup/DetailPopup/DetailPopup';
import { isNumberOnly,maxValue,isRequired, isPrice} from '../../../validation';
import { useCheckboxClick } from '../../../checkboxclick';
import ArchiveSelectedItem from '../../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
import authenticatedAxios from '../../../authenticatedAxios';
import useFilterStore from '../../../store/useFilterStore';
import useRefreshStore from '../../../store/useRefreshStore';
import { useNavigate } from 'react-router-dom';

const pageKey = "plans"


const OurPlans = () => {
  const navigate = useNavigate();
  const { setFilters, getFilters } = useFilterStore();
  const savedFilters = getFilters(pageKey);
  const [items, setItems] = useState([]);
  // const [plans, setPlans] = useState([]);
  const [features, setFeatures] = useState([]);
  const [isDetailPopupOpen,setisDetailPopupOpen] = useState(false)
  const [popupError, setPopupError] = useState('');
  const [currencies, setCurrencies] = useState([]);
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
  // const [isNewPopupOpen, setIsNewPopupOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [searchParams, setSearchParams] = useState(savedFilters?.searchParams || { term: "" });
  const [selectedFilterOption, setSelectedFilterOption] = useState(savedFilters?.selectedFilterOption || "Unarchived");
  const [selectedSortOption, setSelectedSortOption] = useState(savedFilters?.selectedSortOption || "Newest");
  const { refreshKeys } = useRefreshStore();
  const refreshKey = refreshKeys["Our Plans"] || 0;
  const { isParentSelected, selectedItems, handleParentCheckboxChange, handleChildCheckboxChange, resetCheckboxState, } = useCheckboxClick(items);
  const sortOptions = ['A-Z', 'Z-A', 'Newest', 'Oldest'];
  const filterOptions = ['Default', 'Archived', 'Unarchived'];

  useEffect(() => {
    fetchPlans();
    fetchFeatures();
    fetchCurrencies();
    setFilters(pageKey, {
      searchParams,
      selectedFilterOption,
      selectedSortOption,
  });
  }, [searchParams, selectedSortOption, selectedFilterOption]);
  
  const fetchPlans = async (id = null, action = null) => {
    try {
      if (id) {
        const response = await authenticatedAxios.get(`${baseurl}plans/?id=${id}`);
        if (response && response.data) {
          setSelectedItem(response.data.data);
          setIsEditPopupOpen(action === 'edit'); 
          setisDetailPopupOpen(action === 'detail');
        } else {
          if (action === 'edit') {
            setIsEditPopupOpen(true);
          } else if (action === 'detail') {
            setisDetailPopupOpen(true);
          }
        }
      } else {
        const params = {
          search: searchParams.term,
          filter: selectedFilterOption === 'Default' ? undefined : selectedFilterOption.toLowerCase(),
          sort: mapSortOptionToQuery(selectedSortOption),
        };
  
        const response = await authenticatedAxios.get(`${baseurl}plans/`, { params });
        if (response.data.response_code === 1) {
          setItems(response.data.data);
        }
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
    }
  };


  useEffect(() => {
    fetchPlans();
  }, [refreshKey]);
  
  const fetchFeatures = async () => {
    try {
      const response = await authenticatedAxios.get(`${baseurl}plans/feature/`);
      if (response.data.response_code === 1) {
        const featureOptions = response.data.data.map(feature => ({
          label: feature.name,
          value: feature.id,
        }));
        setFeatures(featureOptions);
      } else {
        console.error("Error fetching features:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching features:", error);
    }
  };
  

  const fetchCurrencies = async () => {
    try {
        const response = await authenticatedAxios.get(`${baseurl}currency/`);
        
        const options = (response.data.data || []).map(currency => ({
            label: currency.symbol, 
            value: currency.id 
        }));
        
        setCurrencies(options);
    } catch (error) {
        console.error('Error fetching currencies:', error);
    }
  };
  

  const handleAddPlan = async (formValues) => {
    try {
      const formattedData = {
        plan_name: formValues.plan_name,
        display_name: formValues.display_name,
        trial_period: formValues.trial_period,
        features: formValues.features,
        monthly_price: parseFloat(formValues.monthly_price),
        yearly_price: parseFloat(formValues.yearly_price),
        currency: formValues?.currency,
        is_freeplan: formValues?.is_freeplan || false
      };
  
      const response = await authenticatedAxios.post(`${baseurl}plans/`, formattedData);
      
      if (response.data.response_code === 1) {
        await fetchPlans();
        closePopups();
      } else {
        setPopupError(response.data.message || 'Something went wrong!');
      }
    } catch (error) {
      setPopupError('Failed to add plan. Please try again.');
    }
  };
  
  const handleEditPlan = async (formValues) => {
    try {

      const response = await authenticatedAxios.put(
        `${baseurl}plans/?id=${selectedItem.id}`,
        formValues,
        
      );
  
      if (response.data.response_code === 1) {
        await fetchPlans();
        setPopupError('');
        closePopups();
      } else {
        setPopupError(response.data.message || 'Something went wrong!');
      }
    } catch (error) {
      setPopupError('Failed to edit plan. Please try again.');
    }
  };
  

  const handleArchiveSelectedItems = async () => {
    try {
      const response = await authenticatedAxios.post(`${baseurl}plans/archive/`, {
        id_list: selectedItems,
      });

      if (response.status >= 200 && response.status < 300) {
        fetchPlans();
        resetCheckboxState(); // Clear selection
        closePopups();
      }
    } catch (error) {
      
    }
  };

  const handleArchive = async () => {
    try {
        const response = await authenticatedAxios.get(
            `${baseurl}plans/archive/?id=${selectedItem.id}`
        );

        if (response.status >= 200 && response.status < 300) {
            await fetchPlans(); 
            closePopups(); 
        } 
    } catch (error) {
    }
  };

  const handleArchiveClick = async (item) => {
    setSelectedItem(item);
    setIsArchivePopupOpen(true);
  };

  const mapSortOptionToQuery = (option) => {
    switch (option) {
      case 'A-Z':
        return 'a_to_z';
      case 'Z-A':
        return 'z_to_a';
      case 'Newest':
        return 'newest';
      case 'Oldest':
        return 'oldest';
      default:
        return 'newest';
    }
  };
const handleSortOptionSelect = (option) => {
    setSelectedSortOption(option); 
  };
const handleFilterSelect = (option) => {
    setSelectedFilterOption(option); 
  };

  const handleSearchSelect = (searchTerm) => {
    setSearchParams((prev) => ({ ...prev, term: searchTerm }));
  };

  // const handleNewClick = () => {
  //   setSelectedItem(null);
  //   setIsNewPopupOpen(true);
  // };

  const handleEditClick = (item) => {
    navigate(`/our-plans/edit/${item.id}`);
  };


  const handleDetailClick = (item) => {
    navigate(`/our-plans/detail/${item.id}`);
  };
  

  const closePopups = () => {
    setIsEditPopupOpen(false);
    setisDetailPopupOpen(false);
    setIsArchivePopupOpen(false);
    // setIsNewPopupOpen(false);
    setSelectedItem([]);
    setPopupError('');
  };

  const addPopupFields = [
    { 
      label: 'Plan Name', 
      name: 'plan_name', 
      type: 'large-input', 
      defaultValue: '',
      validators: [isRequired]
    },
    { 
      label: 'Display Name', 
      name: 'display_name', 
      type: 'large-input', 
      defaultValue: '',
      validators: [isRequired]
    },

    {
      label: 'Price Monthly',
      name: 'monthly_price',
      select:'currency',
      type: 'input-select-combo-small',
      options: currencies,
      validators: [isRequired,isPrice]
    },
    {
      label: 'Price Yearly',
      name: 'yearly_price',
      select:'currency',
      type: 'input-select-combo-small',
      options: currencies,
      validators: [isRequired,isPrice]
    },
    { 
      label: 'Trial Period / Days', 
      name: 'trial_period', 
      type: 'large-input', 
      defaultValue: '',
      validators: [isRequired, isNumberOnly, maxValue(365)]
    },
  { 
    label: 'Is Free Plan',
    name: 'is_freeplan',  // Changed from 'is_free_plan' to match Django model
    type: 'toggle',  
    defaultValue: false
  },
    {
      label: 'Add Plan Features',
      name: 'features',
      type: 'features-list',
      allFeatures: features ,
      validators: [isRequired]
    }
    
  ];

  const editPopupFields = [
    { 
      label: 'Plan Name', 
      name: 'plan_name', 
      type: 'large-input', 
      defaultValue: selectedItem?.plan_name || '',
      validators: [isRequired]
    },
    { 
      label: 'Display Name', 
      name: 'display_name', 
      type: 'large-input', 
      defaultValue: selectedItem?.display_name || '',
      validators: [isRequired]
    },
    {
      label: 'Price Monthly',
      name: 'monthly_price',
      select: 'currency',
      type: 'input-select-combo-small',
      options: currencies,
      defaultValue: selectedItem?.monthly_price || '',
      defaultOption: selectedItem?.currency?.id || '',
      validators: [isRequired,isPrice]
    },
    {
      label: 'Price Yearly',
      name: 'yearly_price',
      select: 'currency',
      type: 'input-select-combo-small',
      options: currencies,
      defaultValue: selectedItem?.yearly_price || '',
      defaultOption: selectedItem?.currency?.id || '',
      validators: [isRequired,isPrice]
      
    },
    { 
      label: 'Trial Period / Days', 
      name: 'trial_period', 
      type: 'large-input', 
      defaultValue: selectedItem?.trial_period || '',
      validators: [isRequired, isNumberOnly]
    },
      { 
    label: 'Free Plan',
    name: 'is_freeplan',  // Changed from 'is_free_plan' to match Django model
    type: 'toggle',  
    defaultValue: selectedItem?.is_freeplan || false
  },
    {
      label: 'Add New Features',
      name: 'features',
      type: 'features-list',
      allFeatures: features ,
      defaultValue: selectedItem?.features?.map(feature => feature.id),
      validators: [isRequired]
    }
  ];

  const detailPopupFields = [
    { label: 'Plan Name', type: 'large', value: selectedItem?.plan_name || 'N/A' },
    { label: 'Display Name', type: 'small', value: selectedItem?.display_name || 'N/A' },
    { label: 'Trial Period (Days)', type: 'small', value: selectedItem?.trial_period ? `${selectedItem.trial_period} Days` : 'N/A' },
    { label: 'Monthly Price', type: 'small', value: `${selectedItem?.currency?.symbol || ''} ${selectedItem?.monthly_price || 'N/A'}` },
    { label: 'Yearly Price', type: 'small', value: `${selectedItem?.currency?.symbol || ''} ${selectedItem?.yearly_price || 'N/A'}` },
    
    {
      label: 'Features',
      type: 'features-list',
      value: selectedItem?.features?.map(feature => ({
        label: feature.name,
        id: feature.id
      })) || []
    }
  ];

  const handleExportComplete = () => {
    resetCheckboxState();
  };

  return (
    <div className='whole-container'>
      <div className='top-heading'>
        <PageHeader pageName="Plans /" nestedpageName="Our Plans"  linkTo="" /> 
        <div className='export-container'>

        <ArchiveSelectedItem
          selectedItems={selectedItems}
          items={items}
          onArchiveSelected={handleArchiveSelectedItems}
        />
          <ExportLabel
            exportUrl={`${baseurl}plans/export/`}
            selectedIds={selectedItems}
            onExportComplete={handleExportComplete}
          />
        </div>
      </div>
      <div className='pagename-container'>
        <div className='page-name'>
          <h1 className='common-text fts-22 ftw-6 blue'>Current Plans</h1>
        </div>
        <div className='pagename-right-container'>
          <AddButton onClick={() => navigate('/our-plans/create')} />
          <SimpleSearchBox placeholder="Search Plans" onSearchSelect={handleSearchSelect} defaultValue={searchParams?.term}/>
          <Filter options={filterOptions} onFilterSelect={handleFilterSelect} defaultValue={selectedFilterOption} />
          <Sort options={sortOptions} onOptionSelect={handleSortOptionSelect} defaultValue={selectedSortOption} />
        </div>
      </div>
      <div className='table-container'>
        <table className='common-table'>
          <thead className='common-table-head'>
            <tr className='common-table-thead-tr'>
              <th>
                  <input
                    className="table-selectbox table-parent-selectbox"
                    type="checkbox"
                    checked={isParentSelected}
                    onChange={handleParentCheckboxChange}
                  />PLAN NAME
              </th>
              <th>DISPLAY NAME</th>
              <th>MONTHLY PRICE</th>
              <th>YEARLY PRICE</th>
              <th>TRIAL PERIOD (DAYS)</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody className="common-table-tbody">
            {items.map((plan) => (
              <tr key={plan.id} className={plan.is_archived ? 'archived-item' : ''}>
                <td className='d-flex ai-center'>
                  <input
                    className="table-selectbox table-child-selectbox"
                    type="checkbox"
                    checked={selectedItems.includes(plan.id)}
                    onChange={() => handleChildCheckboxChange(plan.id)}
                  />{plan.plan_name}
                </td>
                <td>{plan.display_name}</td>
                <td>{plan.currency.symbol} {plan.monthly_price}</td>
                <td>{plan.currency.symbol} {plan.yearly_price}</td>
                <td>{plan.trial_period} Days</td>
                <td className="actions common-action">
                  <DetailIcon onClick={() => handleDetailClick(plan)} />
                  <EditIcon onClick={() => handleEditClick(plan)} />
                  <ArchiveIcon onClick={() => handleArchiveClick(plan)} isArchived={plan.is_archived}/>

                </td>
              </tr>
            ))}
          </tbody>         
        </table>
      </div>
      <div>

  </div>
      <EditPopup
        isOpen={isEditPopupOpen}
        title="Edit Plan"
        fields={editPopupFields}
        onSave={handleEditPlan}
        onClose={closePopups}
        popupErrorMessage={popupError}
      />
      <DetailPopup
      isOpen={isDetailPopupOpen}
      title="Plan Details"
      details={detailPopupFields}
      onClose={closePopups}
    />

      <ArchivePopup
        isOpen={isArchivePopupOpen}
        isArchived={selectedItem?.is_archived}
        archivename={selectedItem?.plan_name}
        onSave={handleArchive}
        onClose={() => setIsArchivePopupOpen(false)}
      />

      {/* <AddPopup
        isOpen={isNewPopupOpen}
        title="Plan Details"
        buttonName='Add Plan'
        fields={addPopupFields}
        onSave={handleAddPlan}
        onClose={closePopups}
        popupErrorMessage={popupError}
      /> */}

    </div>
  );
};

export default OurPlans;
